// components/SummaryBar.jsx

const SummaryBar = ({ totalFiles, totalWords }) => {
    if (totalFiles === 0) return null;
  
    return (
      <div className="ml-auto flex justify-end mb-1">
        <div className="px-2 text-md font-medium">
          Word Count:{" "}
          <span className="font-bold text-blue-600">
            {totalWords}
          </span>
          <span className="text-blue-600">
           ({totalFiles})
          </span>
        </div>
      </div>
    );
  };
  
  export default SummaryBar;
  